/**
 * Constantes del feature ordenes
 */

// Cada cuánto se refresca en silencio el listado de estados de compras
export const INTERVALO_REFRESCO_COMPRAS_MS = 30000;

// Cada cuánto se refresca en silencio el listado de estados de ventas
export const INTERVALO_REFRESCO_VENTAS_MS = 30000;
